import React from 'react';
import { useParams } from 'react-router-dom';
import AuthPageTemplate from './template/auth-page';
import ProfileMenu from './../ui/menu/profile';
import config from './../config';
import theme from './../ui/theme';
import CarrierGroupPlanDeliveryPanel from './../ui/panel/carrier-group-plan-delivery';

const CarrierGroupPlanDeliveryPage = () => {
    const { carrierGroupId, deliveryId } = useParams();
    return <AuthPageTemplate childMenu={ <ProfileMenu /> }>
        {
            /* istanbul ignore next */
            config.features.allowCarrierGroups ? 
                <div style={{
                    ...theme.getGeneralTextStyle(theme)
                }}>
                    <CarrierGroupPlanDeliveryPanel
                        carrierGroupId={carrierGroupId}
                        deliveryId={deliveryId}
                    />
                </div> : 
                        <p style={{
                            ...theme.getGeneralTextStyle()
                        }}>
                            This feature is currently disabled
                        </p>
        }

    </AuthPageTemplate>
};

export default CarrierGroupPlanDeliveryPage;
